import {HubConnection, HubConnectionBuilder} from '@microsoft/signalr';
import {eventChannel} from 'redux-saga';
import {AppContext, AppStore} from '~/XeroSignup/sagas';
import {Country, KeyValue} from '~/XeroSignup/types/Types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const formatPhonePrefixes = (prefixOptions: any) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return prefixOptions.map((prefix: any) => {
    return {
      id: prefix.id,
      value: prefix.phonePrefix,
      label: `${prefix.shortName} ${prefix.phonePrefix}`,
    };
  });
};

export const formatCountries = (countryOptions: Country[]) => {
  return countryOptions.map((country: Country) => {
    return {
      id: country.id,
      value: country.code,
      label: country.name,
    };
  });
};

export const getTimeZones = () => {
  // for now only support au
  return [
    {value: 'Australia/Adelaide', label: `UTC +(09:30/10:30) Adelaide`},
    {value: 'Australia/Brisbane', label: `UTC +10 Brisbane`},
    {
      value: 'Australia/Sydney',
      label: `UTC +(10/11) Canberra, Melbourne, Sydney`,
    },
    {value: 'Australia/Darwin', label: `UTC +9:30 Darwin`},
    {value: 'Australia/Perth', label: `UTC +8 Perth`},
  ];
};

export const setValidationRules = (
  formData: KeyValue,
  validationRules: KeyValue
) => {
  const {formMetadata} = formData;
  const {settings} = formMetadata;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  settings.map((data: any) => {
    if (data.name === 'Email') {
      validationRules.item.email = {
        required: true,
        pattern: 'email',
      };
    }

    if (data.name === 'Password') {
      validationRules.item.password = {
        required: true,
        pattern: 'password',
      };
    }

    if (data.name === 'CountryCode') {
      validationRules.item.countryCode = {
        required: true,
      };
    }
  });
};

export function socketConnection(context: AppContext) {
  const {signupApi} = context;

  try {
    const connection = new HubConnectionBuilder()
      .withUrl(`${signupApi.settings.serverUrl}/signup/status`)
      .build();
    return connection;
  } catch (error) {
    // tslint:disable-next-line
    console.log('Failed to connect to Hubs:', error);
  }
}

export function getEventChannel(store: AppStore, connection: HubConnection) {
  const signUpState = store.getState().xeroSignup;

  return eventChannel<{status: 'failure' | 'success'; portalUrl?: string}>(
    emit => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const successHandler = ({autoLoginUrl}: any) => {
        emit({status: 'success', portalUrl: autoLoginUrl});
      };

      const failureHandler = () => {
        emit({status: 'failure'});
      };

      connection.on('onSuccess', successHandler);
      connection.on('onFailure', failureHandler);

      const unsubscribe = () => {
        connection.send('Unsubscribe', signUpState.signupRequestId).then(() =>
          // tslint:disable-next-line
          console.log('Unsubscribed from Hubs')
        );
      };

      return unsubscribe;
    }
  );
}

export function capitalizeFirstLetter(val: string): string {
  if (!val) return '';
  return val[0].toUpperCase() + val.slice(1);
}
